<template>
  <div>
    <transition-group name="fade" v-if="siteLoaderStatus && showSite">
      <div class="sections" key="2">
        <TopNav />
        <Landing />
        <Flex />
        <Seating />
        <SeatingBK />
        <Banner bannerDivider="fans" />
        <Notice />
        <Banner bannerDivider="field" />
        <CoreBenefits />
        <!-- <DoubleBenefits /> -->
        <!-- <Gifts /> -->
        <!-- <Pricing /> -->
        <Banner bannerDivider="renew" />
        <!-- <Testimonials /> -->
        <Renew />
        <Payment />
        <Membership />
        <Schedule />
        <Banner bannerDivider="crowd" />
        <Faq />
        <Footer />
      </div>
    </transition-group>
    <transition
      name="fade"
      v-else
    >
      <SiteLoader @setLoaderFinished="setLoaderFinished" />
    </transition>
  </div>
</template>

<script>
import SiteLoader from "@/components/global/SiteLoader";
import { mapActions, mapState } from "vuex";
import TopNav from "@/components/TopNav/TopNav";
import Landing from "@/components/sections/Landing/Landing";
import Flex from "@/components/sections/Flex/Flex";
import Notice from "@/components/sections/Notice/Notice";
import CoreBenefits from "@/components/sections/CoreBenefits/CoreBenefits";
import Banner from "@/components/sections/Banner/Banner";
// import DoubleBenefits from "@/components/sections/DoubleBenefits/DoubleBenefits";
// import Gifts from "@/components/sections/Gifts/Gifts";
import Seating from "@/components/sections/Seating/Seating";
import SeatingBK from "@/components/sections/Seating/SeatingBK";
// import Pricing from "@/components/sections/Pricing/Pricing";
// import Testimonials from "@/components/sections/Testimonials/Testimonials";
import Renew from "@/components/sections/Renew/Renew";
import Payment from "@/components/sections/Payment/Payment";
import Schedule from "@/components/sections/Schedule/Schedule";
import Footer from "@/components/sections/Footer/Footer";
import Membership from '../sections/Membership/Membership.vue';
import Faq from '../sections/Faq/Faq.vue';
export default {
  name: "Layout",
  components: {
    SiteLoader,
    TopNav,
    Landing,
    Flex,
    Notice,
    CoreBenefits,
    Banner,
    // DoubleBenefits,
    // Gifts,
    Seating,
    SeatingBK,
    // Pricing,
    // Testimonials,
    Renew,
    Payment,
    Schedule,
    Footer,
    Membership,
    Faq
  },
  computed: {
    ...mapState(["global"])
  },
  data() {
    return {
      showSite: false,
      siteLoaderStatus: false
    };
  },
  mounted() {
    //this.firstMount = true;
    //this.setIsMobile(window.innerWidth < 992);
    //window.addEventListener(
    //  "resize",
    //  () => {
    //    this.setIsMobile(window.innerWidth < 992);
    //  },
    //  false
    //);
    this.$store.watch(
      (state) => {
        return this.$store.state.global.userInfo
      },
      (newValue, oldValue) => {
        if (newValue) {
          setTimeout(() => {
            this.showSite = true;
          }, 0);
        }
      }
    );
  },
  methods: {
    setLoaderFinished(status) {
      this.siteLoaderStatus = status;
    },
    ...mapActions(["setIsMobile"])
  }
};
</script>

<style lang="scss" scoped>
/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.map {
  width: 100%;
  // height: 100%;
  object-fit: contain;
}
</style>